import { render, staticRenderFns } from "./SingleBuy.vue?vue&type=template&id=41181735&scoped=true"
import script from "./SingleBuy.vue?vue&type=script&lang=ts"
export * from "./SingleBuy.vue?vue&type=script&lang=ts"
import style0 from "./SingleBuy.vue?vue&type=style&index=0&id=41181735&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41181735",
  null
  
)

export default component.exports